import { getParagraph, getExplain } from '../createRender';

let reverseParseTextView = data => {
    let obj = createRender(data);

    return obj;
}

function createRender(data) {
    if (!data.stem) {
        return {}
    }

    // 题干
    let stem = getParagraph(data.stem);
    // 答案
    let answer = data.answer ? getAnswer(data.answer) : null;
    // 解析
    let explain = data.explain ? getExplain(data.explain) : null;

    const render = { stem, answer, explain };
    return render;
}

const getAnswer = (answer) => {
    try {
        answer = JSON.parse(answer);
    } catch (error) {
        answer = [];
    }
    return answer;
};

export { reverseParseTextView };


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/sudoku/createRender.js